import { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import SocialAdsBuilderModal from './SocialAdsBuilderModal';

function HomepageBannerModal({ isOpen, onClose }) {
  const [bannerContent, setBannerContent] = useState({
    title: 'كرّموا من خدموا الوطن',
    subtitle: 'التخفيضات يوم المحاربين القدامى',
    buttonText: 'تسوق الآن',
    image: 'https://i.ibb.co/82xMFc1/NOV002-2-07abbaea-3e7d-4c61-8034-9d6593ae1833-1080x.webp'
  });
  const [showImageBuilder, setShowImageBuilder] = useState(false);

  const handleGenerate = () => {
    // TODO: Implement banner generation
    console.log('Generating banner with content:', bannerContent);
  };

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl">
                <div className="absolute right-0 top-0 pr-4 pt-4">
                  <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500"
                    onClick={onClose}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" />
                  </button>
                </div>

                <div className="p-6">
                  <h2 className="text-xl font-semibold mb-6">Homepage Banner Preview</h2>

                  {/* Banner Preview */}
                  <div className="bg-gray-50 rounded-lg p-6 mb-6">
                    <div className="flex flex-col lg:flex-row items-center justify-between gap-8" style={{ direction: 'rtl' }}>
                      <div className="text-center lg:text-right">
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">{bannerContent.title}</h2>
                        <p className="text-gray-600 mb-6">{bannerContent.subtitle}</p>
                        <button className="px-6 py-3 bg-[#0049ac] text-white rounded-lg hover:bg-[#0049ac]/90">
                          {bannerContent.buttonText}
                        </button>
                      </div>
                      <div className="flex-shrink-0">
                        <img 
                          src={bannerContent.image}
                          alt="Banner"
                          className="w-64 h-64 object-contain"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Banner Content Form */}
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Banner Title
                      </label>
                      <input
                        type="text"
                        value={bannerContent.title}
                        onChange={(e) => setBannerContent(prev => ({ ...prev, title: e.target.value }))}
                        className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                        dir="rtl"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Banner Subtitle
                      </label>
                      <input
                        type="text"
                        value={bannerContent.subtitle}
                        onChange={(e) => setBannerContent(prev => ({ ...prev, subtitle: e.target.value }))}
                        className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                        dir="rtl"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Button Text
                      </label>
                      <input
                        type="text"
                        value={bannerContent.buttonText}
                        onChange={(e) => setBannerContent(prev => ({ ...prev, buttonText: e.target.value }))}
                        className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                        dir="rtl"
                      />
                    </div>

                    <div className="flex justify-end space-x-4">
                      <button
                        onClick={handleGenerate}
                        className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600"
                      >
                        Save Generation
                      </button>
                      <button
                        onClick={() => setShowImageBuilder(true)}
                        className="px-4 py-2 bg-[#0049ac] text-white rounded-lg hover:bg-[#0049ac]/90"
                      >
                        Generate New Image
                      </button>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>

        <SocialAdsBuilderModal 
          isOpen={showImageBuilder}
          onClose={() => setShowImageBuilder(false)}
        />
      </Dialog>
    </Transition.Root>
  );
}

export default HomepageBannerModal;